import React, { ReactNode } from 'react';

interface AmplitudeMaskProps {
  children: ReactNode;
  style?: React.CSSProperties;
  blockStyleMask?: boolean;
}

const AmplitudeMask = ({
  children,
  style,
  blockStyleMask,
}: AmplitudeMaskProps) => {
  return (
    <div className={blockStyleMask ? 'amp-block' : 'amp-mask'} style={style}>
      {children}
    </div>
  );
};

export default AmplitudeMask;
